import React from "react";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {push} from "connected-react-router";

import {Grid, Link} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";

import { setChannelWorkflowGridStateUpdate } from 'store/actions';
import { Constants } from "../../../../utilities/constants";
import { addCommaSeparatorToNumber } from '../../../../utilities/format';
import { sendClientLog } from 'services/logService';

const {
  INITIAL,
  COUNTER,
  DUEDILIGENCE,
  IMPORTED,
  PRESCREEN,
} = Constants.OpportunityStatus;

const { SAVEDPRICING, SAVEDNOBID, AUTOPRICED, SUBMITTEDNOBID, SUBMITTEDPRICING, PENDING } = Constants.UnderwriteStatus;

const MyTasksGridRow = ({
  channels,
  classes,
  dashboardAvailableTasks,
  dashboardTasks,
  dashboardChannels,
  push,
  setChannelWorkflowGridStateUpdate,
  tasksType,
  tasksText,
  user,
}) => {
  function handleRedirectToWorkflow(channel) {
    if (getTaskTypeCount(channel) === 0 || !user?.roles?.underwriteUser) {
      return;
    }

    sendClientLog('Info', 'User clicked link on dashboard to navigate to workflow (' + channel + ', ' + tasksType + ').');

    let underwriteStatus = [];
    let assignedUserName = [];
    let opportunityStatuses = [];
    const filterValue = [['channelText', '=', channel]];

    switch (tasksType) {
      case 'Imported':
        opportunityStatuses = [IMPORTED];
        break;
      case 'Available':
        assignedUserName = [null];
        underwriteStatus = [null, AUTOPRICED];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE];
        break;
      case 'Assigned':
        assignedUserName = [user.fullName];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'Incomplete':
        assignedUserName = [user.fullName];
        underwriteStatus = [null];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'Autopriced':
        assignedUserName = [user.fullName];
        underwriteStatus = [AUTOPRICED];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'Pending':
        assignedUserName = [user.fullName];
        underwriteStatus = [PENDING];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'SavedPricing':
        assignedUserName = [user.fullName];
        underwriteStatus = [SAVEDPRICING];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'SavedNoBid':
        assignedUserName = [user.fullName];
        underwriteStatus = [SAVEDNOBID];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'SubmittedPricing':
        assignedUserName = [user.fullName];
        underwriteStatus = [SUBMITTEDPRICING];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
      case 'SubmittedNoBid':
        assignedUserName = [user.fullName];
        underwriteStatus = [SUBMITTEDNOBID];
        opportunityStatuses = [INITIAL, COUNTER, DUEDILIGENCE, PRESCREEN];
        break;
    }
    
    filterValue.push(['opportunityStatus', 'anyof', opportunityStatuses]);
    if (underwriteStatus.length > 0) {
      filterValue.push(['underwriteStatus', 'anyof', underwriteStatus]);
    }
    if (assignedUserName.length > 0) {
      filterValue.push(['userName', 'anyof', assignedUserName]);
    }

    setChannelWorkflowGridStateUpdate({ filterValue }, true);
    push(Constants.Routes.CHANNEL_WORKFLOW);
  }

  function getTaskTypeCount(channel) {
    return getCurrentDataSet().filter(f => f.channel === channel && f.dashboardTaskType === tasksType)[0]?.count || 0;
  }

  function calculateTotal() {
    return getCurrentDataSet()
      .filter( f => f.dashboardTaskType === tasksType)
      .reduce((acc, current) => acc + current.count, 0);
  }

  function getCurrentDataSet() {
    return (tasksType === 'Imported' || tasksType === 'Available') ? dashboardAvailableTasks : dashboardTasks;
  }

  function getGridHeaderClass(channel) {
    if (dashboardChannels.indexOf(channel) < 0) {
      return classes.greyed;
    }
  }

  function getRow() {
    return channels.map((channel) => (
      <Grid
        key={channel.name}
        item
        xs={1}
        className={`${getGridHeaderClass(channel.name)} ${classes.gridCell}`}
      >
        <Link
          color={'inherit'}
          href="#"
          onClick={() => handleRedirectToWorkflow(channel.name)}>
            {addCommaSeparatorToNumber(getTaskTypeCount(channel.name))}
        </Link>
      </Grid>
    ));
  }

  return (
    <Grid container className={classes.gridRow}>
      <Grid item xs={6}>
        <span style={{marginLeft: 10, fontWeight: 600}}>{tasksText ?? tasksType}</span>
      </Grid>
      {getRow()}
      <Grid
        item
        xs={1}
        className={`${classes.totalColumn} ${classes.gridCell}`}>
        {addCommaSeparatorToNumber(calculateTotal())}
      </Grid>
    </Grid>
  );
}

const styles = theme => ({
  gridRow: {
    marginBottom: '5px',
    borderTop: '1px solid black',
    paddingRight: 10,
  },
  greyed: {
    color: 'rgba(200, 200, 200, 0.85)',
  },
  totalColumn: {
    fontWeight: '700',
    textAlign: 'end',
  },
  gridCell: {
    textAlign: 'end',
    fontSize: 13,
    fontFamily: 'Roboto, RobotoFallback, Helvetica, Arial, sans-serif'
  }
});

const mapDispatchToProps = {
  setChannelWorkflowGridStateUpdate,
  push
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    null,
    mapDispatchToProps
  )
)(MyTasksGridRow);
